import { render } from "./VerticalResourceBar.vue?vue&type=template&id=031755f5"
import script from "./VerticalResourceBar.vue?vue&type=script&lang=js"
export * from "./VerticalResourceBar.vue?vue&type=script&lang=js"

import "./VerticalResourceBar.vue?vue&type=style&index=0&id=031755f5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__